<ul>
    
    <li *ngFor="let item of items">
        <a [routerLink]="item.link" *ngIf="item.link">{{ item.title }}</a>
        <span *ngIf="!item.link">{{ item.title }}</span>
    </li>
    <!-- <li><a href="#">Cartões</a></li> -->
</ul>